import { LoggerService } from '../../utils/logger.service';
import { ViewChild } from "@angular/core";
import { ModulesManagerService } from "../Module/modules-manager.service";

export class Documents {

    private manager: ModulesManagerService;
    private id: number = 0;
    private fileName: string = "none";
    private mimeType: string = "none";
    private parentId: number = 0;
    private size: number = 0;
    private parentModule: string = "";
    private base64: string = "";
    private imported: boolean = true;
    private integrityChecked: boolean = false;
    private currentLoad = false

    private try = 0;
    private maxTry = 15


    constructor(manager: ModulesManagerService, Data: any = null) {
        this.manager = manager
        if (Data)
            this.Hydrate(Data)
    }


    async Hydrate(Data, UpdateAnnex = false) {
        this.try = 0
        for (const [propertie, values] of Object.entries(Data))
            this[this.manager.Tool.minimilizeFirstChar(propertie)] = values
        if (UpdateAnnex) {

        }
        if (this.parentId && this.parentModule && this.id > 0)
            await this.checkIntegrity()

        if (!this.base64 && this.id > 0) {
            let fetched = await this.manager.Ws.Send("Documents", "getBase64", { Id: this.id, ParentId: this.parentId, ParentModule: this.parentModule }, true).catch(e => LoggerService.error("DocumentsService getBase64 error:", e))
            if (fetched.Data)
                this.base64 = fetched.Data
        }
        if (this.base64) await this.manager.Documents.writeFileFromB64(this.Directory, this.fileName, this.base64, false).catch(e => LoggerService.error("DocumentsService writeFileFromB64 error:", e))
    }

    get Id() {
        return this.id
    }

    get Mime() {
        return this.mimeType
    }

    get FileName() {
        return this.fileName
    }

    get Directory() {
        if (this.parentId == 0 || this.parentModule == "") throw new Error("No module given, unable to generate Directory path");
        return this.parentModule + this.parentId
    }

    get isNotLoaded() {
        return !this.imported || !this.integrityChecked || this.currentLoad || !this.base64
    }

    get PictureSrc() {
        if (!this.imported || !this.integrityChecked || this.currentLoad) return this.manager.Documents.DefautPicture
        this.getPictureData()
        return this.base64 ? this.base64 : this.manager.Documents.DefautPicture;
    }

    get PicturSrcV2() {
        return this.PictureSrc.split(";base64,").pop()
    }

    public async StorePictureFromEvent(Module: string, ModuleId: number, event: any) {
        this.imported = false
        this.parentId = ModuleId;
        this.parentModule = Module
        let file = event.target.files[0]
        this.mimeType = file.type
        this.fileName = Date.now() + '.' + (file.name.split(".").pop())
        if (!await this.manager.Documents.writeFileFromBlob(this.Directory, this.fileName, file).catch(e => { LoggerService.error("DocumentsService writeFileFromBlob error:", e); return false; })) {
            this.manager.Tool.notify(this.manager.Trad.Parse("STR_ERROR"))
            this.manager.deleteModuleData("Documents", this.id)
            return
        }
        this.imported = true
        this.integrityChecked = true
        await this.getPictureData()
    }

    public async StorePictureFromBlob(Module: string, ModuleId: number, blob: Blob) {
        let event = {
            target: {
                files: [blob]
            }
        }
        await this.StorePictureFromEvent(Module, ModuleId, event)
    }

    get fullFilePath() {
        return this.Directory + "/" + this.fileName
    }

    private async checkIntegrity() {
        await this.loadLocalBase64()
        if (this.size != this.base64.length) {
            this.base64 = ""
            await this.manager.Documents.deleteFile(this.fullFilePath)
            this.integrityChecked = true
        }
        this.integrityChecked = true
    }

    private async loadLocalBase64() {

        const file = (await this.getFile().catch(e => { LoggerService.error("DocumentsService getFile error:", e); return null }))


        this.base64 = file?.data ? "data:" + this.mimeType + ";base64," + file?.data : ""
    }

    private async getFile() {
        return await this.manager.Documents.getFile(this.fullFilePath, false)
    }


    public async getPictureData() {
        if (this.imported && this.integrityChecked && !this.currentLoad && this.base64 == "") {

            this.try++
            this.currentLoad = true
            await this.loadLocalBase64()
            this.currentLoad = false
            if (this.base64)
                await this.manager.Documents.writeFileFromB64(this.Directory, this.fileName, this.base64, false).catch(e => LoggerService.error("DocumentsService writeFileFromB64 2 error:", e))

        }
    }


    public isParentOf(Module, Id): boolean {
        return this.parentId == Id && Module == this.parentModule
    }

    public canDisplayAs(Type) {
        switch (Type) {
            case "img":
                return this.mimeType.includes("image")
        }
        return false
    }

    public async removeFile() {
        await this.manager.Documents.deleteFile(this.fullFilePath)
        this.manager.deleteModuleData("Documents", this.id)
        if (this.id > 0)
            this.manager.Ws.Send("Documents", 'delete', { Id: this.id })
    }

    public async exportData(): Promise<any> {
        await this.getPictureData()
        this.size = (this.base64 as string).length

        return {
            Id: this.id,
            FileName: this.fileName,
            MimeType: this.mimeType,
            ParentId: this.parentId,
            ParentModule: this.parentModule,
            Base64: this.base64,
            Size: this.size
        }
    }

    public async sendToServer() {
        if (this.parentId > 0) {
            let answer = await this.manager.Ws.Send("Documents", 'create', await this.exportData(), true)
            if (answer.success) {
                this.manager.deleteModuleData("Documents", this.id)
            }
        }
    }

    public async viewDocument() {
        if (this.canDisplayAs("img"))
            this.manager.Documents.viewDocument(this)
        else
            await this.manager.Documents.fileOpen(this)
    }

    public async confirmDelete(confirmDocumentAlert) {

        confirmDocumentAlert.presentAlert({
            header: this.manager.Trad.Parse('STR_DELETE'),
            message: this.manager.Trad.Parse('STR_DOCUMENT_DELETE_CONFIRM'),
            cssClass: 'confirm-delete-alert',
            buttons: [
                {
                    text: this.manager.Trad.Parse('STR_CANCEL'),
                },
                {
                    text: this.manager.Trad.Parse('STR_DELETE'),
                    handler: () => { this.removeFile() },
                    cssClass: 'delete-button',
                },
            ],
        })
    }

}
